<div class="validation-container">
    <div class="validation-card">

        <div class="spinner"></div>

        <h2>Validando información...</h2>

        <p>
            Estamos verificando los datos proporcionados.
            Serás redirigido automáticamente en unos instantes.
        </p>

    </div>
</div>